// =============================================================================
// TOKENS DE FORMULARIOS - SISTEMA DE DISEÑO TADMIN
// =============================================================================
// Tokens para componentes de formularios: select, form, field, fileUpload

import colors from './colors.js';
import typography from './typography.js';
import spacing from './spacing.js';
import shadows from './shadows.js';
import borders from './borders.js';

// Desestructuración segura de typography
const typographyData = typography || {};
const fontFamily = typographyData.fontFamilies || {};
const fontSize = typographyData.fontSizes || {};
const fontWeight = typographyData.fontWeights || {};
const lineHeight = typographyData.lineHeights || {};

// =============================================================================
// TOKENS PARA SELECT
// =============================================================================
export const selectTokens = {
  trigger: {
    backgroundColor: colors.light.background.default,
    border: borders.component.input.default,
    borderRadius: borders.radius.input,
    padding: '8px 12px',
    fontSize: fontSize.sm,
    lineHeight: lineHeight.normal,
    color: colors.light.text.primary,
    cursor: 'pointer',
    '&:focus': {
      border: borders.component.input.focus,
      boxShadow: shadows.component.input.focus,
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
  },
  content: {
    backgroundColor: colors.light.surface.elevated,
    border: borders.component.card.default,
    borderRadius: borders.radius.md,
    boxShadow: shadows.component.card.elevated,
    padding: '4px',
    zIndex: 50,
    minWidth: '8rem',
  },
  item: {
    padding: '6px 32px 6px 8px',
    fontSize: fontSize.sm,
    borderRadius: borders.radius.sm,
    cursor: 'pointer',
    color: colors.light.text.primary,
    '&:focus': {
      backgroundColor: colors.light.primary.light,
      color: colors.light.primary.contrast,
    },
    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.5,
    },
  },
  indicator: {
    position: 'absolute',
    left: '8px',
    width: '14px',
    height: '14px',
  },
};

// =============================================================================
// TOKENS PARA FORM
// =============================================================================
export const formTokens = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.spacing[6],
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.spacing[2],
  },
  message: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    color: colors.light.error.main,
  },
};

// =============================================================================
// TOKENS PARA FIELD
// =============================================================================
export const fieldTokens = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.spacing[2],
    marginBottom: spacing.spacing[4],
  },
  label: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    color: colors.light.text.primary,
  },
  required: {
    color: colors.light.error.main,
    marginLeft: spacing.spacing[1],
  },
  description: {
    fontSize: fontSize.xs,
    color: colors.light.text.secondary,
    marginTop: spacing.spacing[1],
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.spacing[4],
  },
  set: {
    border: borders.component.card.default,
    borderRadius: borders.radius.md,
    padding: spacing.spacing[4],
  },
  legend: {
    fontSize: fontSize.base,
    fontWeight: fontWeight.semiBold,
    color: colors.light.text.primary,
    padding: `0 ${spacing.spacing[2]}`,
  },
  separator: {
    height: '1px',
    backgroundColor: colors.light.border.default,
    margin: `${spacing.spacing[4]} 0`,
  },
};

// =============================================================================
// TOKENS PARA FILE UPLOAD
// =============================================================================
export const fileUploadTokens = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.spacing[2],
  },
  dropzone: {
    border: `2px dashed ${colors.light.border.default}`,
    borderRadius: borders.radius.md,
    padding: spacing.spacing[6],
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: colors.light.primary.main,
      backgroundColor: colors.light.primary.light,
    },
    '&.dragover': {
      borderColor: colors.light.primary.main,
      backgroundColor: colors.light.primary.light,
    },
  },
  fileInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.spacing[2],
    padding: spacing.spacing[3],
    backgroundColor: colors.light.surface.elevated,
    borderRadius: borders.radius.sm,
    border: borders.component.card.default,
  },
  fileName: {
    fontSize: fontSize.sm,
    color: colors.light.text.primary,
    flex: 1,
  },
  removeButton: {
    color: colors.light.error.main,
    cursor: 'pointer',
    padding: spacing.spacing[1],
    borderRadius: borders.radius.sm,
    '&:hover': {
      backgroundColor: colors.light.error.light,
    },
  },
  error: {
    fontSize: fontSize.sm,
    color: colors.light.error.main,
    display: 'flex',
    alignItems: 'center',
    gap: spacing.spacing[1],
  },
  uploading: {
    opacity: 0.6,
    pointerEvents: 'none',
  },
};